export default {
    tips:{
      errCode:{
        400:"参数错误",
        403:"权限受限，请联系管理员",
        404:"请求链接不存在，请联系管理员",
        405:"请求方式不正确，应为POST/GET",
        500:"服务器错误，请联系管理员",
        default:"无效的请求，状态码（$），请联系管理员",
        other:"未知错误，请联系管理排查"
      }
    },
    pageName: "ERP系统",// 正式服记得改
    // branch:"dev",
    urlPrefix: "/back", // 正式服记得改
    localhost:"https://erp.dev.medext.cn",
    host:"https://erp.medext.cn",
    logo:"http://kclass.imedunion.com/image/logo.png", 
    websocketHost:"",
    types:{
      exports:{
        zip:'application/zip',
        xlsx:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
      },
      files:{
        attachment:"erp_project_attachment"
      },
      have_contract: [
        {label: "有",value: 1},
        {label: "无",value: 0}
      ],
      contractType: [
        {
          label: "开口合同",
          value: 1,
        },
        {
          label: "闭口合同",
          value: 0,
        },
      ],
      cancelAuditResult:["未申请","申请中","申请通过","申请驳回"],
      operationStatus:["进行中","已完结"],
      auditResult:["未审核","通过","驳回"],
      auditExecutorResult:["未审核","已同意","已拒绝"],
      disabledStatus: ["否", "是"],
      userLevel:["超级管理员","领导","普通"],
      projectType: ["无营收", "有营收"],
      // projectDemandType:["平台综合类", "医学物料类","美化或视频类","项目执行类"],//项目需求类型
    projectDemandType:[
        {
            index:0,
            label:"线上会议（含飞派，研讨会定制模式）"
        },
        {
            index:1,
            label:"医学物料定制"
        },
        {
            index:2,
            label:"仅设计或美化需求"
        },
        {
            index:3,
            label:"项目执行（1除外）"
        },
        {
            index:4,
            label:"IT开发定制"
        },
        {
            index:5,
            label:"医学研究类"
        }
      ],
    newProjectDemandType:[
      {
          index:6,
          label:"AI定制类"
      },
      {
          index:7,
          label:"医学定制类"
      },
      {
          index:8,
          label:"AI工具账号类"
      },
      {
          index:9,
          label:"学术会议/可视化类"
      },
    ],//项目需求类型
      subTaskType:{
          0:["无制作类型"],
          1:["幻灯制作","幻灯更新","推文/图文制作","推文/图文更新","DA/手册制作","DA/手册更新","文献类"],
          2:["创意视频制作","创意视频更新","幻灯美化"],
          3:["会议执行","物料审核"]
      },//需求类型对应的制作类型
      invoiceType: ["普通发票", "增值税专用发票"],
      mailType: ["是", "否，电子版即可"],
      status: ["是", "否"],
      taskType: ["医学物料", "项目执行及美化协助", "大型项目或开发需求"],
    },
    wxinterface:[
      "startRecord",
      "stopRecord",
      "onVoiceRecordEnd",
      "playVoice",
      "pauseVoice",
      "stopVoice",
      "onVoicePlayEnd",
      "uploadVoice",
      "downloadVoice",
      "closeWindow",
      "scanQRCode",
      "updateAppMessageShareData",
      "onMenuShareAppMessage",
      "onMenuShareTimeline",
      "updateTimelineShareData",
  ],
  toolbarConfig: {
    toolbarKeys: [
        // 菜单 key
        // 'headerSelect',
        // // 分割线
        'color',
        "underline",
        "numberedList",
        // "indent",
        // "delIndent"
        {
            "key": "group-indent",
            "title": "缩进",
            "menuKeys": [
                "indent",
                "delIndent"
            ]
        },
        '|',
        "fontSize"
    ],
}

}